import React, {createContext, useContext, useEffect, useState} from 'react';
import {useAuth} from 'react-oidc-context';

const defaultFeaturesContext = {
    isFeatureEnabled: () => false,
    loading: false
};

const FeaturesContext = createContext(defaultFeaturesContext);

export const useFeaturesConfig = () => useContext(FeaturesContext);

export const FeaturesProvider = ({children}) => {
    const {user} = useAuth();
    const [features, setFeatures] = useState({});
    const [loading, setLoading] = useState(true);

    const fetchFeatures = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${window.ENV.BACKEND_URL}/api/secured/feature/config`, {
                headers: {
                    Authorization: `Bearer ${user?.access_token}`
                }
            });
            const data = await response.json();

            const featuresMap = data?.features?.reduce((acc, feature) => {
                acc[feature.name] = feature.enabled;
                return acc;
            }, {});

            setFeatures(featuresMap);
        } catch (error) {
            console.error('Failed to fetch features config:', error);
            setFeatures({});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchFeaturesAsync = async () => {
            await fetchFeatures();
        };

        fetchFeaturesAsync();
    }, []);

    const isFeatureEnabled = (featureName) => {
        if (loading) {
            return false;
        }
        if (!features || Object.keys(features).length === 0) {
            return false;
        }
        return features[featureName] === true;
    };

    return (
        <FeaturesContext.Provider value={{isFeatureEnabled, loading}}>
            {children}
        </FeaturesContext.Provider>
    );
};
